const INTEREST_LIMITS = {
  FROM: 0.1,
  UP_TO: 30,
  STEP: 0.01,
};

export default INTEREST_LIMITS;
